<template>
  <MultiStepDialog
    ref="dialogRef"
    :steps="steps"
    variant="passport"
    :size="maxTablet ? 'full' : undefined"
    :side="maxTablet ? 'default' : 'right'"
    :dismissible="!componentRef?.editing"
    :showFooter="componentRef?.editing === true"
    :confirmLabel="$t('components.buttons.save')"
    :disableConfirm="!componentRef?.isDirty"
    :closeOnCancel="false"
    :closeOnConfirm="false"
    :withBackdropButton="withBackdropButton"
    @update:open="$emit('update:open', $event)"
    @cancel="componentRef?.cancel()"
    @confirm="componentRef?.submit()"
  >
    <template #header="{ step }">
      <Component
        ref="headerRef"
        :is="step.header"
        v-bind="step.headerProps"
        :viewport="viewport"
        @delete="$emit('delete')"
      />
    </template>
    <template #content="{ step, props, handleGoToStep, handleStepBack }">
      <Component
        ref="componentRef"
        :is="step.content"
        v-bind="props"
        :viewport="viewport"
        @goToStep="handleGoToStep"
        @back="handleStepBack"
        @update="$emit('update', $event)"
        @update:item="$emit('update:item', $event)"
        @reload:item="$emit('reload:item', $event)"
      />
    </template>
    <template
      v-if="steps[dialogRef?.currentStep]?.footer"
      #footer="{ step, footerProps, handleStepBack }"
    >
      <Component
        :is="step.footer"
        v-bind="footerProps"
        @reassign="$emit('reassign')"
        @createTask="$emit('createTask', $event)"
        @cancel="handleStepBack"
      />
    </template>
  </MultiStepDialog>
</template>

<script setup>
import { computed, ref } from "vue";
import { MultiStepDialog } from "@/SharedComponents/Dialogs";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { usePassport } from "@/Composables/usePassport";

const { maxTablet } = useBreakpoints();

const dialogRef = ref(null);
const headerRef = ref(null);
const componentRef = ref(null);

defineEmits([
  "update:open",
  "update",
  "update:item",
  "delete",
  "reassign",
  "createTask",
]);

const props = defineProps({
  type: { type: String, required: true },
  item: { type: Object, required: true },
  insights: { type: Object, required: false },
  withBackdropButton: { type: Boolean, default: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const { steps } = usePassport(
  props.type,
  computed(() => props.item)
);

defineExpose({
  close: () => headerRef.value?.close() ?? dialogRef.value?.close(),
});
</script>
